<template>
  <div class="my-wallet-content ali">
    <div class="account">
      <img src="../imgs/lianlian-wallet.png" alt="">
      <div class="account-btns">
        <el-button v-if="!company" v-permission="['air:agent:account:withdraw']" size="small" type="primary" @click="toWithdrawal">
          提现
        </el-button>
        <el-button v-if="company" v-permission="['air:product:account:no-pass-auth']" size="small" type="primary" @click="toNonSecretAuth">
          免密授权
        </el-button>
        <el-button size="small" type="primary" @click="toManage">
          管理
        </el-button>
      </div>
    </div>

    <div class="account-money">
      <div v-if="company" :class="['account-money-item', company ? '!w-[50%]' : '']">
        <div class="title">
          待结算金额(元)
        </div>
        <div class="money">
          {{ isNull(data?.airbillCompanyLianInfo?.frozenBalance) ? '--' : data?.airbillCompanyLianInfo?.frozenBalance }}
        </div>
      </div>
      <div :class="['account-money-item', company ? '!w-[50%]' : '']">
        <div class="title">
          可用余额(元)
        </div>
        <div class="money">
          {{ isNull(availableMoeny) ? '--' : availableMoeny }}
        </div>
      </div>
    </div>
  
    <div class="account-info">
      <div class="left">
        <div class="account-info-title">
          <span v-if="company" class="label">企&nbsp;&nbsp;&nbsp;业：</span>
          <span v-else class="label">代理商：</span>
          <span class="value">{{ company ? isNull(data?.airbillCompanyLianInfo?.name) ? '--' : data?.airbillCompanyLianInfo?.name : isNull(data?.airbillAgentLianInfo?.name) ? '--' : data?.airbillAgentLianInfo?.name }}</span>
        </div>
        <div class="account-info-title">
          <span class="label">账&nbsp;&nbsp;&nbsp;户：</span>
          <span class="value">{{ company ? isNull(data?.airbillCompanyLianInfo?.lianNo) ? '--' : data?.airbillCompanyLianInfo?.lianNo : isNull(data?.airbillAgentLianInfo?.lianNo) ? '--' : data?.airbillAgentLianInfo?.lianNo }}</span>
        </div>
      </div>
      <el-popover popper-class="homepage-wallet-popover" placement="bottom-end" :width="460">
        <template #reference>
          <span class="account-info-btn">详细信息
            <svg-icon class="!w-3" icon="uiw:down" />
          </span>
        </template>
  
        <el-scrollbar scroll-y class="h-[300px]">
          <!-- 企业端 -->
          <company-bill-lian-info v-if="company" />

          <!-- 代理商端 -->
          <agent-bill-lian-info v-else />
        </el-scrollbar>
      </el-popover>
    </div>
  </div>
</template>

<script setup lang='ts'>
import CompanyBillLianInfo from './CompanyBillLianInfo.vue';
import AgentBillLianInfo from './AgentBillLianInfo.vue';
import { SvgIcon } from '@vue3/components';
import { inject, Ref, computed } from 'vue';
import { IFinanceWallet } from '@core/main/types/finance';
import { isNull } from '@core/tools';
import { EPaymentStepKey } from '@core/main/types';
import { useRouter } from 'vue-router';

const emit = defineEmits(['reload']);
const router = useRouter();

const props = defineProps({
  company: {
    type: Boolean,
    default: false,
  },
});

const data = inject<Ref<IFinanceWallet>>('data');

const availableMoeny = computed(() => props.company ? data.value?.airbillCompanyLianInfo?.availableBalance : data.value?.airbillAgentLianInfo?.withDrawable);

function toNonSecretAuth() {
  router.push({
    name: 'ManagePaymentAccount',
    query: {
      step: EPaymentStepKey.NoPassAuth,
      lianId: data.value?.airbillCompanyLianInfo?.lianId || undefined,
      openBank: data.value?.airbillCompanyLianInfo?.openBank || undefined,
      channel: isNull(data.value?.airbillCompanyLianInfo?.channelId) ? undefined : data.value?.airbillCompanyLianInfo?.channelId,
      storeType: isNull(data.value?.airbillCompanyLianInfo?.type) ? undefined : data.value?.airbillCompanyLianInfo?.type,
    },
  });
}

function toManage() {
  const lianId = props.company ? data.value?.airbillCompanyLianInfo?.lianId : data.value?.airbillAgentLianInfo?.lianId;
  const type = props.company ? data.value?.airbillCompanyLianInfo?.type : undefined;
  const form = props.company ? 'payer' : 'lianlian';

  router.push(`/air-splitting/lianlian/manage?lianId=${lianId}&from=${form}&storeType=${type}`);
}

const toWithdrawal = () => {
  router.push({
    name: 'LianliantoWithdrawal',
    query: { lianId: data.value?.airbillAgentLianInfo?.lianId },
  });
};
</script>

<style lang="scss" scoped src="../style/my-wallet.scss" />